export default __webpack_public_path__ + "static/RecPoolImage-bed463f1264a267594d12acfcf14f83c.png";